var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3629 15.0932C29.6636 16.4606 31.3139 17.1443 31.8186 18.1067C32.2762 18.9792 32.2762 20.0208 31.8186 20.8933C31.3139 21.8557 29.6636 22.5394 26.3629 23.9068L12.488 29.655C9.22732 31.0058 7.59696 31.6813 6.56341 31.3623C5.62616 31.0731 4.8895 30.344 4.59066 29.4097C4.26111 28.3795 4.91975 26.7423 6.23704 23.4679L7.83333 19.4999L6.2371 15.5322C4.91979 12.2577 4.26114 10.6205 4.59069 9.59029C4.88953 8.65607 5.62619 7.92693 6.56344 7.6377C7.59699 7.31875 9.22736 7.99419 12.4881 9.34506L26.3629 15.0932Z",
    fill: "url(#paint0_linear_4192_9905)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4192_9905",
    x1: 37,
    y1: 19.5,
    x2: 2,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.f67ab399d70f0d973ba038bd55ba2a2c.svg";
export { ForwardRef as ReactComponent };